import React from 'react'
import MaterialUITabs from '@mui/material/Tabs'
import MaterialUITab from '@mui/material/Tab'

import RenderTabLabel from 'components/ParticipantProfile/RenderTabLabel'
import { a11yProps } from 'lib/Helper'

const Tab = ({
  activeTabIndex,
  handleChangeTab,
  a11ylabel,
  a11yPropsKey,
  items,
}: {
  activeTabIndex: number
  handleChangeTab: (event: React.SyntheticEvent, tabIndex: number) => void
  a11ylabel: string
  a11yPropsKey: string
  items: string[]
}) => {
  return (
    <MaterialUITabs
      value={activeTabIndex}
      onChange={handleChangeTab}
      aria-label={a11ylabel}
      variant="fullWidth"
    >
      {items.map((item: string, index: number) => {
        return (
          <MaterialUITab
            label={RenderTabLabel(item)}
            key={index}
            {...a11yProps(a11yPropsKey, index)}
            data-testid={`${item}-tab`}
          />
        )
      })}
    </MaterialUITabs>
  )
}

export default Tab
